import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {ProductService} from '../../services/product-service';
import {MatDialogRef} from '@angular/material/dialog';
import {Product} from '../../products/product';
import { HttpErrorResponse } from '@angular/common/http';
import {StringUtils} from '../../utils/string-utils';
import { MatButton } from '@angular/material/button';
import { MatList, MatListItem } from '@angular/material/list';


@Component({
    selector: 'app-add-product-dialog',
    templateUrl: './add-product-dialog.component.html',
    styleUrls: ['./add-product-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatList, MatListItem, MatButton]
})
export class AddProductDialogComponent implements OnInit {
  private readonly productService = inject(ProductService);
  private dialogRef = inject<MatDialogRef<AddProductDialogComponent>>(MatDialogRef);


  readonly products = signal<Product[]>(undefined!);
  selectedProduct!: Product;
  readonly errorMessage = signal<string>(undefined!);

  ngOnInit(): void {
    this.productService.getProductConfigurations().subscribe(products => {
      this.products.set(products.sort((first, second) => first.productId.localeCompare(second.productId)));
    }, error => this.handleError(error));
  }

  private handleError(error: HttpErrorResponse): void {
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  close(): void {
    this.dialogRef.close(null);
  }

  selectProduct(product: Product): void {
    this.selectedProduct = product;
  }

  isSelected(product: Product): boolean {
    return this.selectedProduct && (this.selectedProduct.productId === product.productId);
  }

  addProduct(): void {
    if (this.selectedProduct) {
      this.dialogRef.close(this.selectedProduct.productId);
    }
  }

}
